<sc-flex [fitHeight]="true" [vertical]="true" [stretchContent]="true">
  <sc-dialog-title>{{'register transport' | translate : ['tmc.transport.registration.title',
    translationService.language]}}</sc-dialog-title>
  <div class="stepper-title-bar" *ngIf="this.registration!= null && this.registration.transport != null">
    <div class="title-part" *ngFor="let st of stepperModel.componentTitles; let i = index">
      <div class="divider" *ngIf="i>0">></div>
      <div class="step-title"
        [ngClass]="{'active': stepperModel.currentComponentIndex >= i, 'disabled': i==2 && this.registration.transport.masterdata.managementLevel === TransportManagementLevel.LIFECYCLE}">
        {{'stepper title' | translate : [ st, translationService.language]}}</div>
    </div>
  </div>
  <sc-flex-fitting-content [vertical]="true">
    <ng-container *ngIf="registration">
      <sc-scroll-pane>
        <app-master-data [readonly]="readonly" [registration]="registration" [stepperModel]="stepperModel"
          *ngIf="this.stepperModel.currentComponentIndex === 0" (valueChange)="handleValueChange()"></app-master-data>

        <app-transport-options [registration]="registration" [stepperModel]="stepperModel"
          *ngIf="this.stepperModel.currentComponentIndex === 1"></app-transport-options>

        <app-route [registration]="registration" [stepperModel]="stepperModel"
          *ngIf="this.stepperModel.currentComponentIndex === 2"></app-route>

        <app-supplementary-equipment [registration]="registration" [stepperModel]="stepperModel"
          *ngIf="this.stepperModel.currentComponentIndex === 3"></app-supplementary-equipment>

      </sc-scroll-pane>
    </ng-container>
  </sc-flex-fitting-content>
  <div class="messages">
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
  </div>
  <sc-padding [formGroup]="formGroup">
    <sc-flex>
      <button mat-stroked-button (click)="showPreviousStep()" [disabled]="showPreviousStepDisabled()"
        *ngIf="isPreviousStepVisible()">{{'previous' | translate : ['tmc.transport.registration.action.previous',
        translationService.language]}}</button>
      <ng-container *ngIf="this.stepperModel.currentComponentIndex === 0">
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <sc-checkbox-field formControlName="registerArrival" [label]="'register arrival' | translate : ['tmc-yard.widgets.transport-registration.checkbox.register-arrival',
            translationService.language]"></sc-checkbox-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-checkbox-field formControlName="registerEntrance" [label]="'register entrance' | translate : ['tmc-yard.widgets.transport-registration.checkbox.register-entrance',
            translationService.language]"></sc-checkbox-field>
      </ng-container>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" [disabled]="isCancelDisabled()" class="cancel-button"
        (click)="cancel()">{{'cancel' | translate: ['tmc.transport.registration.action.cancel',
        translationService.language]}}</button>
      <ng-container *ngIf="showNextStepButtonVisible()">
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="showNextStep()" [disabled]="showNextStepDisabled()"
          class="confirm-button">{{'next' | translate : ['tmc.transport.registration.action.next',
          translationService.language]}}</button>
      </ng-container>
      <ng-container *ngIf="showFinishButtonVisible()">
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button class="confirm-button" (click)="finish()" [disabled]="finishDisabled()">{{'finish' |
          translate : ['tmc.transport.registration.action.finish', translationService.language]}}</button>
      </ng-container>
    </sc-flex>
  </sc-padding>
</sc-flex>